@if (dirtyCastedActivities) {
  @for (
    activity of dirtyCastedActivities;
    track trackByActivities(i, activity);
    let i = $index
  ) {
    @if (
      {
        activityStartTime: activity | ganttActivityStartTime,
        activityEndTime: activity | ganttActivityEndTime,
        isActivityStartLocationMismatch:
          dirtyCastedActivities
          | ganttIsActivityStartLocationMismatch: activity.id,
        isActivityEndLocationMismatch:
          dirtyCastedActivities
          | ganttIsActivityEndLocationMismatch: activity.id,
        isMoveMode: dragAndDropModeService.isMoveMode$ | async,
        isReported: activity.activityReports?.length,
      };
      as data
    ) {
      <wilson-timeline-auto-size-activity-card
        [activity]="activity"
        [containerWidthPx]="containerWidthPx"
        [accurateActivityStartDateTime]="data.activityStartTime.date"
        [activityStartTimeDifference]="data.activityStartTime.timeDifference"
        [accurateActivityEndDateTime]="data.activityEndTime.date"
        [activityEndTimeDifference]="data.activityEndTime.timeDifference"
        [activityStartTimeType]="data.activityStartTime.type"
        [activityEndTimeType]="data.activityEndTime.type"
        [accurateContainerStartDateTime]="accurateStartDateTime"
        [accurateContainerEndDateTime]="accurateEndDateTime"
        [shiftActivities]="dirtyCastedActivities"
        [accurateContainerDurationMs]="accurateContainerDurationMs"
        [filteredActivityId]="filteredActivityId"
        [isActivityStartLocationMismatch]="data.isActivityStartLocationMismatch"
        [isActivityEndLocationMismatch]="data.isActivityEndLocationMismatch"
        [isCursorGrab]="isCursorGrab"
        [userId]="userId"
        [isDraggable]="isActivityDraggable"
        (click)="handleSelectedActivity($event)"
      ></wilson-timeline-auto-size-activity-card>
    }
  }
}
